import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query-keys'
import { cmsService } from '@/services/cms'
import type { ScientificCorporaItem } from '@/services/cms'

export function useScientificCorpora() {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: queryKeys.cms.scientificCorpora({ limit: 100, offset: 0 }),
    queryFn: () => cmsService.getScientificCorpora({ limit: 100, offset: 0 }),
  })

  const sections = data?.results ?? []
  const allItems: ScientificCorporaItem[] = sections.flatMap(section => section.items)

  return {
    sections,
    allItems,
    count: data?.count ?? 0,
    isLoading,
    isError,
    error,
  }
}
